import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {SignUpUpdate, SignUpUpdateParams} from 'domain/usecases';

export class RemoteSignUpUpdate implements SignUpUpdate {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<void>,
	) {}

	async signUpUpdate(params: SignUpUpdateParams): Promise<void> {
		const {login_token, ...bodyParams} = params;

		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'patch',
			body: bodyParams,
			headers: {
				Authorization: `Bearer ${login_token}`,
				'Ocp-Apim-Subscription-Key': process.env.API_BFF_AZURE_SUBSCRIPTION_KEY,
			},
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
